<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-col cols="12">
      <v-alert v-if="errors" prominent type="error" color="red" dense>{{ errors }}</v-alert>
      <v-alert v-if="success" prominent type="success" color="green" dense>{{ success }}</v-alert>
    </v-col>
    <v-card-title>
      Doctor Statement
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" md="3">
        <v-autocomplete
            v-model="doctor_id"
            item-text="dr_name"
            item-value="id"
            :items="doctors"
            label="Select Doctor"
            dense
            hide-details
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="3">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="dateRangeLabel"
                label="Select Date [Start Date, End Date]"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              @click:date="dateSelect"
              range
              :max="nowDate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn
                depressed
                color="primary"
                append-icon="mdi-printer"
                v-on:click="printList"
            >Print
            </v-btn>
          </v-row>
        </template>
      </v-col>

      <v-col cols="12" sm="6" md="2" v-if="isSuperAdmin">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn
                depressed
                color="success"
                append-icon="mdi-file-document-outline"
                v-on:click="printPaymentSummaryReport"
            >Payment Summary Print
            </v-btn>
          </v-row>
        </template>
      </v-col>

      <v-col cols="12" md="2">
        <template>
          <v-row align="center" justify="space-around" v-if="isSingleDayToday">
              <v-btn
                  depressed
                  color="primary"
                  append-icon="mdi-printer"
                  v-on:click="openPaymentDialog"
              >Get Payment
              </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>

    <!-- Empty State when no doctor selected -->
    <v-card v-if="!doctor_pay.dr_id" class="text-center py-8">
      <v-card-text>
        <v-icon size="64" color="grey lighten-1">mdi-doctor</v-icon>
        <p class="text-h6 mt-4 grey--text">Please select a doctor to view payment statement</p>
      </v-card-text>
    </v-card>

    <!-- Payment Statement Content -->
    <div v-if="doctor_pay.dr_id">
      <v-card id="print">
        <strong>Consultation</strong>
        <v-data-table
            :headers="consultancy_header"
            :items="consultancy_desserts"
            class="elevation-1"
            :search="search"
            :loading="loadingstatus"
            :hide-default-footer="true"
            disable-pagination
        >
          <template v-slot:item.slno="{ item }">
            {{ consultancy_desserts.indexOf(item) + 1 }}
          </template>
          <template slot="body.append">
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>

              <th></th>
              <th></th>
              <th></th>
              <th v-if="desserts[0]">
                {{ desserts[0].consultancy_ledger }}
              </th>
              <th>{{ this.hospital_consultancy_payable_amount }}</th>
            </tr>
          </template>
        </v-data-table>
        <br />
        <strong>Operation</strong>
        <v-data-table
            :headers="operation_header"
            :items="operation_desserts"
            class="elevation-1"
            :search="search"
            :loading="loadingstatus"
            :hide-default-footer="true"
            disable-pagination
        >
          <template v-slot:item.slno="{ item }">
            {{ operation_desserts.indexOf(item) + 1 }}
          </template>

          <template v-slot:item.invoice_amount="{ item }">
            {{ item.invoice_amount }}
            <div v-if="item.referral_type == 1">[Referral]</div>
            <div v-else-if="item.referral_type == 2">[Anesthesia]</div>
            <div v-else-if="item.referral_type == 3">[Ext. Dr]</div>
          </template>
          <template slot="body.append">
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th v-if="desserts[0]">
                {{ desserts[0].ot_ledger }}
              </th>
              <th>{{ this.ot_hospital_payment }}</th>
            </tr>
          </template>
        </v-data-table>
        <br />
        <strong>Internal Referral: Received </strong>
        <v-data-table
            :headers="internal_referral_received_header"
            :items="internal_referral_received_desserts"
            class="elevation-1"
            :search="search"
            :loading="loadingstatus"
            :hide-default-footer="true"
            disable-pagination
        >
          <template v-slot:item.slno="{ item }">
            {{ internal_referral_received_desserts.indexOf(item) + 1 }}
          </template>
          <template slot="body.append">
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th v-if="desserts[0]">
                {{ desserts[0].doctor_internal_receive }}
              </th>
              <th></th>
            </tr>
          </template>
        </v-data-table>
        <br />
        <strong>Internal Referral: Transfer</strong>
        <v-data-table
            :headers="internal_referral_transfer_header"
            :items="internal_referral_transfer_desserts"
            class="elevation-1"
            :search="search"
            :loading="loadingstatus"
            :hide-default-footer="true"
            disable-pagination
        >
          <template v-slot:item.slno="{ item }">
            {{ internal_referral_transfer_desserts.indexOf(item) + 1 }}
          </template>
          <template slot="body.append">
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th v-if="desserts[0]">
                {{ desserts[0].doctor_internal_transfer }}
              </th>
              <th></th>
            </tr>
          </template>
        </v-data-table>
        <br />
        <strong>Refund To Patient</strong>
        <v-data-table
            :headers="refund_header"
            :items="refund_desserts"
            class="elevation-1"
            :search="search"
            :loading="loadingstatus"
            :hide-default-footer="true"
            disable-pagination
        >
          <template v-slot:item.slno="{ item }">
            {{ refund_desserts.indexOf(item) + 1 }}
          </template>
          <template slot="body.append">
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th v-if="desserts[0]">
                {{ desserts[0].patient_refund }}
              </th>
              <th></th>
            </tr>
          </template>
          <template v-slot:item.remarks="{ item }">
            <span v-html="item.remarks"></span>
          </template>
        </v-data-table>
        <br />
        <strong>Doctor Payment </strong>
        <v-data-table
            :headers="doctor_payment_header"
            :items="[]"
            class="elevation-1"
            :search="search"
            :loading="loadingstatus"
            :hide-default-footer="true"
            disable-pagination
        >
          <template v-slot:body>
            <tbody>
            <template v-for="(block, blockIndex) in doctorPaymentBlocks">
              <tr v-if="blockIndex > 0" :key="'spacer-' + blockIndex" class="doctor-payment-date-spacer">
                <td colspan="6"></td>
              </tr>
              <tr v-if="block.isGroup" :key="'group-' + blockIndex">
                <td colspan="6" class="font-weight-bold grey lighten-4 doctor-payment-date-header">
                  {{ block.dateLabel }}
                </td>
              </tr>
              <tr
                  v-for="(item, itemIndex) in block.items"
                  :key="'payment-' + blockIndex + '-' + itemIndex"
              >
                <td>{{ getDoctorPaymentSlNo(blockIndex, itemIndex) }}</td>
                <td>{{ formatPaymentDateTime(item.created_at) }}</td>
                <td>{{ item.user ? item.user.full_name : '-' }}</td>
                <td>{{ getReceivedByName(item) }}</td>
                <td>{{ item.payment_note }}</td>
                <td>{{ item.payment_amount }}</td>
              </tr>
            </template>
            <tr v-if="doctor_payment_desserts.length">
              <th colspan="5" class="text-right"></th>
              <th v-if="desserts[0]">{{ desserts[0].doctor_paid }}</th>
            </tr>
            </tbody>
          </template>
        </v-data-table>
        <br />
        <strong>OT Receivable Items</strong>
        <v-data-table
            :headers="doctor_receivable_header"
            :items="doctor_receivable_desserts"
            class="elevation-1"
            :search="search"
            :loading="loadingstatus"
            :hide-default-footer="true"
            disable-pagination
        >
        </v-data-table>
        <br />
        <strong>Summary </strong>
        <template>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Title</th>
                <th class="text-left">Amount</th>
                <th class="text-left">Qty</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Opening Balance</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].opening_balance }}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Consultation</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].consultancy_ledger }}
                </td>
                <td v-if="desserts[0]">
                  {{ desserts[0].consultancy_statement.length }}
                </td>
              </tr>

              <tr>
                <td>Operation</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].ot_ledger }}
                </td>
                <td v-if="desserts[0]">
                  {{ desserts[0].ot_ledger_statement.length }}
                </td>
              </tr>
              <tr>
                <td>Due Collection</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].due_collection }}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Internal Referral: Received</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].doctor_internal_receive }}
                </td>
                <td v-if="desserts[0]">
                  {{ desserts[0].doctor_internal_receive_statement.length }}
                </td>
              </tr>
              <tr>
                <th class="text-right">Total Collection</th>
                <td v-if="desserts[0]">
                  {{ (desserts[0].doctor_income).toFixed(2) }}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Internal Referral: Transfer</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].doctor_internal_transfer }}
                </td>
                <td v-if="desserts[0]">
                  {{ desserts[0].doctor_internal_transfer_statement.length }}
                </td>
              </tr>
              <tr>
                <td>Refund To Patient</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].patient_refund }}
                </td>
                <td v-if="desserts[0]">
                  {{ desserts[0].patient_refund_statuement.length }}
                </td>
              </tr>
              <tr>
                <td>Doctor Payment</td>
                <td v-if="desserts[0]">
                  {{ desserts[0].doctor_paid }}
                </td>
                <td></td>
              </tr>
              <tr>
                <th class="text-right">Total Distribution</th>
                <td v-if="desserts[0]">
                  {{ desserts[0].distribution }}
                </td>
                <td></td>
              </tr>
              <tr>
                <th class="text-right">Balance</th>
                <td v-if="desserts[0]">
                  {{ (desserts[0].balance).toFixed(2) }}
                </td>
                <td></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table> </template
        ></v-card>
    </div>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2" v-if="desserts[0]">
              [{{ desserts[0].dr_id }}] {{ desserts[0].dr_name }}
            </v-card-title>
            <v-card-text>
              <p v-if="desserts[0]">
                Opening Balance: {{ desserts[0].opening_balance }}<br /> <br>
                <v-row>
                  <v-col cols="8">
                    <v-text-field col-md-6
                                  v-model="doctor_pay.amount"
                                  outlined
                                  dense
                                  min="0"
                                  label="Payment Amount"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                        v-model="doctor_pay_closing_amount"
                        outlined
                        dense
                        min="0"
                        label="Closing Amount"
                        readonly
                        grey
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-radio-group
                    row
                    v-model="doctor_pay.received_by_type"
                    outlined
                    dense
                >
                  <v-radio label="Received By Representative" value="Received By Representative"></v-radio>
                  <v-radio label="Received By Doctor" value="Received By Doctor"></v-radio>
                </v-radio-group>
                <v-autocomplete
                    v-if="doctor_pay.received_by_type === 'Received By Representative'"
                    :items="users"
                    v-model="doctor_pay.received_by_user_id"
                    :loading="loadingstatus"
                    item-text="full_name"
                    item-value="id"
                    label="Received By"
                    outlined
                    dense
                ></v-autocomplete>

                <v-textarea
                    v-model="doctor_pay.note"
                    label="Note"
                    outlined
                    dense
                ></v-textarea>

              </p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-if="spinnerButtons">
                <v-progress-circular :width="12" size="61" color="green" indeterminate style="margin-top: 5px; margin-bottom: 10px"></v-progress-circular>
              </div>
              <div v-else>
                <v-btn
                    color="warning"
                    outlined
                    text
                    @click="dialog = false"
                    :loading="loadingstatus"
                >
                  Cancel
                </v-btn>

                <v-btn
                    v-if="doctor_pay.id"
                    color="info"
                    outlined
                    text
                    @click="submit"
                    :loading="loadingstatus"
                >
                  Pay Now
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}

.doctor-payment-date-spacer td {
  height: 14px;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
}

.doctor-payment-date-header {
  padding-top: 8px !important;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment/moment";

export default {
  data() {
    return {
      spinnerButtons: false,
      search: "",
      dialog: false,
      errors: null,
      success: null,
      // errors: [],
      doctors: [],
      hospital_consultancy_payable_amount: 0,
      doctor_id: this.$route.query.doctor_id || 0,
      doctor_pay: {
        id: null,
        dr_id: null,
        amount: null,
        closing_amount: null,
        note: null,
        received_by_user_id: '',
        received_by_type: '',
      },

      date: (() => {
        const today = moment().format('YYYY-MM-DD');
        const queryDate = this.$route.query.date;
        const selectedDate = queryDate && queryDate <= today ? queryDate : today;
        return [selectedDate, selectedDate];
      })(),
      nowDate: moment().format('YYYY-MM-DD'),
      menu2: false,
      loadingstatus: false,
      login_user_id: localStorage.getItem("userId"),
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
      superAdminUserIds: [1, 50, 63],
      headers: [
        { text: "Doctor Name", value: "dr_name" },
        { text: "Consultation", value: "consultancy_ledger" },
        {
          text: "Internal Referral: Received",
          value: "doctor_internal_receive",
        },
        { text: "OT Ledger", value: "ot_ledger" },
        {
          text: "Internal Referral: Transfer",
          value: "doctor_internal_transfer",
        },
        { text: "Refund", value: "patient_refund" },
        { text: "Paid Amount", value: "doctor_paid" },
        { text: "Balance", value: "balance" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      consultancy_header: [
        { text: "SL", value: "slno" },
        { text: "Invoice ID", value: "invoice_id" },
        { text: "Patient ID", value: "patient_id" },
        { text: "Patient Phone", value: "patient.patient_phone" },
        { text: "BILL", value: "sub_total" },
        { text: "Discount", value: "discount_amount" },
        { text: "Receive", value: "paid_amount" },
        { text: "Due", value: "due_amount" },
        { text: "Doctor", value: "doctor_payable" },
        { text: "Hospital", value: "hospital_payable" },
        { text: "PayMethod", value: "payment_method" },
      ],
      consultancy_desserts: [],
      users: [],
      overses_desserts: [],
      ot_hospital_payment: 0,
      operation_header: [
        { text: "SL", value: "slno" },
        { text: "Reg. ID", value: "invoice_id" },
        { text: "Patient ID", value: "operaton_patient.patient_id" },
        { text: "Patient Name", value: "operaton_patient.patient.patient_name",},
        { text: "Patient Phone", value: "operaton_patient.patient.patient_phone",},
        { text: "Referral Doctor", value: "operaton_patient.referral_doctor.dr_name",},
        { text: "Operation Name", value: "operaton_patient.operation.name" },
        { text: "Ot Bill", value: "operaton_patient.ot_amount" },
        { text: "Receive", value: "operaton_patient.paid_amount" },
        { text: "Due", value: "operaton_patient.proposed_due_amount" },
        { text: "Surgeon", value: "invoice_amount" },
        { text: "Hospital", value: "operaton_patient.hospital_amount" },
      ],
      operation_desserts: [],
      internal_referral_received_header: [
        { text: "SL", value: "slno" },
        { text: "Invoice ID", value: "invoice_id" },
        { text: "Patient ID", value: "patient_id" },
        { text: "Referral Doctor", value: "ref_from_name" },
        { text: "Referral Amount", value: "ref_from_fee" },
        { text: "Invoice Amount", value: "total_invoice_amount" },
      ],
      internal_referral_received_desserts: [],
      internal_referral_transfer_header: [
        { text: "SL", value: "slno" },
        { text: "Invoice ID", value: "invoice_id" },
        { text: "Patient ID", value: "patient_id" },
        { text: "Referral Doctor", value: "ref_to_name" },
        { text: "Referral Amount", value: "ref_to_fee" },
        { text: "Invoice Amount", value: "total_invoice_amount" },
      ],
      internal_referral_transfer_desserts: [],
      refund_header: [
        { text: "SL", value: "slno" },
        { text: "Invoice ID", value: "invoice_id" },
        { text: "Patient ID", value: "patient_id" },
        { text: "Note", value: "remarks" },
        { text: "Doctor Ledger Amount", value: "doctor" },
        { text: "Refund Amount", value: "refund_amount" },
      ],
      refund_desserts: [],

      doctor_receivable_header: [
        { text: "Reg. ID", value: "registration_no" },
        { text: "Patient ID", value: "patient_id" },
        {
          text: "Patient Name",
          value: "patient.patient_name",
        },
        { text: "Operation Name", value: "operation.name" },
        { text: "OT Date", value: "opp_date" },
        { text: "Receive Amount", value: "paid_amount" },
      ],
      doctor_receivable_desserts: [],

      doctor_payment_header: [
        { text: "SL", value: "slno" },
        { text: "Date & Time", value: "created_at" },
        { text: "Paid By", value: "user.full_name" },
        { text: "Received By", value: "received_by_user_id" },
        { text: "Note", value: "payment_note" },
        { text: "Amount", value: "payment_amount" },
      ],
      doctor_payment_desserts: [],

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Doctor Statement",
          disabled: true,
          href: "patients",
        },
      ],
    };
  },

  created() {
    this.getDoctors();
    if (this.doctor_id && this.isDateRangeComplete) {
      this.getReports();
    }
    this.getUserList();
  },
  computed: {
    normalizedDateRange() {
      let dates = [];
      if (Array.isArray(this.date)) {
        dates = this.date.filter(function (selectedDate) {
          return !!selectedDate;
        });
      } else if (this.date) {
        dates = [this.date];
      }

      if (dates.length < 2) {
        return null;
      }

      return dates.slice(0, 2).sort();
    },
    isDateRangeComplete() {
      return this.normalizedDateRange !== null;
    },
    dateRangeLabel() {
      const range = this.normalizedDateRange;
      if (range) {
        if (range[0] === range[1]) {
          return range[0];
        }
        return range[0] + " to " + range[1];
      }

      const pendingDates = Array.isArray(this.date)
          ? this.date.filter(function (selectedDate) {
            return !!selectedDate;
          })
          : [];

      if (pendingDates.length === 1) {
        return pendingDates[0] + " (select end date)";
      }

      return "";
    },
    isSingleDayToday() {
      const range = this.normalizedDateRange;
      return !!(range && range[0] === range[1] && range[1] === this.nowDate);
    },
    isSuperAdmin() {
      const loginUserId = parseInt(localStorage.getItem("userId"), 10);
      const userRole = parseInt(localStorage.getItem("user_role"), 10);
      return this.superAdminUserIds.includes(loginUserId) || userRole === 1;
    },
    // a computed getter
    doctor_pay_closing_amount: function () {
      // `this` points to the vm instance
      return (parseFloat(this.doctor_pay.closing_amount) - parseFloat(this.doctor_pay.amount)).toFixed(2);
    },
    doctorPaymentBlocks() {
      const sortedPayments = [...this.doctor_payment_desserts].sort((a, b) => {
        const aTime = moment(a.created_at || a.payment_date);
        const bTime = moment(b.created_at || b.payment_date);
        return aTime.valueOf() - bTime.valueOf();
      });

      const blocks = [];
      let index = 0;

      while (index < sortedPayments.length) {
        const payment = sortedPayments[index];
        const dateKey = moment(payment.created_at || payment.payment_date).format('YYYY-MM-DD');
        const sameDayItems = [];

        while (
            index < sortedPayments.length &&
            moment(sortedPayments[index].created_at || sortedPayments[index].payment_date).format('YYYY-MM-DD') === dateKey
        ) {
          sameDayItems.push(sortedPayments[index]);
          index++;
        }

        blocks.push({
          isGroup: sameDayItems.length > 1,
          dateLabel: moment(dateKey).format('DD MMM, YYYY'),
          items: sameDayItems,
        });
      }

      return blocks;
    },
  },
  methods: {
    validateSelectedDate() {
      const dates = this.normalizedDateRange || (
          Array.isArray(this.date) ? this.date.filter(function (selectedDate) {
            return !!selectedDate;
          }) : []
      );
      const hasFutureDate = dates.some(function (selectedDate) {
        return selectedDate && selectedDate > this.nowDate;
      }.bind(this));

      if (hasFutureDate) {
        this.$noty.error("Future date cannot be selected");
        this.date = [this.nowDate, this.nowDate];
        return false;
      }

      return true;
    },
    applyDateRange() {
      if (!this.isDateRangeComplete) {
        this.loadingstatus = false;
        this.errors = null;
        return false;
      }

      if (!this.validateSelectedDate()) {
        this.loadingstatus = false;
        return false;
      }

      this.date = this.normalizedDateRange.slice();
      this.menu2 = false;
      return true;
    },
    getReceivedByName(item) {
      if (item.received_by_user_id && item.received_by && item.received_by.full_name) {
        return item.received_by.full_name;
      }
      if (item.doctor && item.doctor.dr_name) {
        return item.doctor.dr_name;
      }
      return '-';
    },
    formatPaymentDateTime(value) {
      if (!value) {
        return '-';
      }
      return moment(String(value)).format('DD MMM, YYYY hh:mm A');
    },
    getDoctorPaymentSlNo(blockIndex, itemIndex) {
      let slNo = 0;
      for (let i = 0; i < blockIndex; i++) {
        slNo += this.doctorPaymentBlocks[i].items.length;
      }
      return slNo + itemIndex + 1;
    },
    refreshPaymentModal(resetReceivedBy = true) {
      if (this.desserts[0]) {
        this.doctor_pay.id = this.desserts[0].id;
        this.doctor_pay.dr_id = this.desserts[0].dr_id;
        this.doctor_pay.amount = parseFloat(this.desserts[0].balance).toFixed(2);
        this.doctor_pay.closing_amount = this.desserts[0].balance;
        this.doctor_pay.note = this.desserts[0].opening_balance
            ? "Opening balance: " + this.desserts[0].opening_balance
            : "";
      }
      if (resetReceivedBy) {
        this.doctor_pay.received_by_type = '';
        this.doctor_pay.received_by_user_id = '';
      }
    },
    openPaymentDialog() {
      this.refreshPaymentModal();
      this.dialog = true;
    },
    submit() {
      if (this.doctor_pay.id == null || this.doctor_pay.amount <= 0) {
        this.$noty.error("Please insert positive value");
        return false;
      }

      if (!this.doctor_pay.received_by_type) {
        this.$noty.error("Please select received by");
        return false;
      }

      if (
        this.doctor_pay.received_by_type === 'Received By Representative' &&
        !this.doctor_pay.received_by_user_id
      ) {
        this.$noty.error("Please select received by user");
        return false;
      }

      this.errors = null;
      this.$swal({
        title: 'Are you sure about the payment to the doctor?',
        text: "You won't be able to revert this!",
        type: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!'
      }).then((result) => {
        if (result.value) {
          this.loadingstatus = true;
          this.spinnerButtons = true
          atshq
              .post("doctor/payment", {
                date: this.normalizedDateRange ? this.normalizedDateRange[1] : this.nowDate,
                data: this.doctor_pay,
                closing_amount: this.doctor_pay_closing_amount,
                received_by_user_id: this.doctor_pay.received_by_user_id,
                received_by_type: this.doctor_pay.received_by_type,
                user_id: localStorage.getItem("userId"),
              })
              .then((response) => {
                this.loadingstatus = false;
                this.spinnerButtons = false;
                this.dialog = false;
                const successMessage = response.data.messages || response.data.message || 'Payment saved successfully';
                this.success = successMessage;
                this.$noty.success(successMessage);
                this.getReports();
              })
              .catch((e) => {
                const errorMessage = (e.response && e.response.data && e.response.data.message)
                    ? e.response.data.message
                    : 'Payment failed';
                this.errors = errorMessage;
                this.$noty.error(errorMessage);
                this.loadingstatus = false;
                this.spinnerButtons = false;
              });
        } else {
          this.loadingstatus = false;
          this.spinnerButtons = false;
        }
      });
    },
    getReports() {
      if (!this.doctor_id) {
        this.errors = "Please select doctor";
        this.loadingstatus = false;
        return false;
      }
      if (!this.isDateRangeComplete) {
        this.loadingstatus = false;
        this.errors = null;
        return false;
      }
      if (!this.validateSelectedDate()) {
        this.loadingstatus = false;
        return false;
      }

      const dateQuery = this.normalizedDateRange.join(",");
      this.loadingstatus = true;
      this.errors = null;
      atshq
          .get("doctor/statement?doctor_id=" + this.doctor_id + "&date=" + dateQuery + "&login_user_id=" + this.login_user_id)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.desserts = response.data.data;
            this.hospital_consultancy_payable_amount = this.desserts[0].hospital_consultancy_payable_amount;
            this.ot_hospital_payment = this.desserts[0].ot_hospital_payment;
            this.doctor_receivable_desserts = response.data.data[0].receivable;
            this.consultancy_desserts = response.data.data[0].consultancy_statement;
            this.consultancy_myopia_perform_doctor_desserts = response.data.data[0].consultancy_myopia_perform_ref_dr_statement;
            this.consultancy_myopia_paediatric_doctor_desserts = response.data.data[0].consultancy_myopia_paediatric_ref_dr_statement;
            this.consultancy_myopia_ref_desserts = response.data.data[0].consultancy_myopia_ref_dr_statement;
            this.operation_desserts = response.data.data[0].ot_ledger_statement;

            this.overses_desserts = response.data.data[0].overseas_statement;

            this.internal_referral_received_desserts =
                response.data.data[0].doctor_internal_receive_statement;
            this.internal_referral_transfer_desserts =
                response.data.data[0].doctor_internal_transfer_statement;
            this.refund_desserts = response.data.data[0].patient_refund_statuement;
            this.doctor_payment_desserts = response.data.data[0].doctor_paid_statement;
            this.doctor_id = this.desserts[0].id;
            this.refreshPaymentModal(!this.dialog);
            this.loadingstatus = false;
            this.errors = null;
          })
          .catch((e) => {
            this.loadingstatus = false;
            if (e.response && e.response.data && e.response.data.message) {
              this.errors = e.response.data.message;
            } else {
              this.errors = "Failed to load doctor statement";
            }
          });
    },
    getDoctors() {
      atshq
          .get("/doctors?status=1")
          .then((response) => {
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors = true;
            this.errorMessage = e;
          });
    },
    dateSelect() {
      if (!this.applyDateRange()) {
        return;
      }
      this.getReports();
    },
    getUserList() {
      atshq
          .get("users/user")
          .then((response) => {
            this.users = response.data.data;
            this.loading_status = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    printList() {
      if (!this.desserts[0] || !this.isDateRangeComplete) {
        return false;
      }
      const range = this.normalizedDateRange;
      let date = moment(range[0]).format('MMMM DD, YYYY') + " - " + moment(range[1]).format('MMMM DD, YYYY');
      if (range[0] === range[1]) {
        date = moment(range[0]).format('MMMM DD, YYYY');
      }
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=950, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:12px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px; }"
      );
      docprint.document.write("table th, table th {text-align: center;}");
      docprint.document.write("table {width: 100%; border-spacing: 0px;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(
          '<h2 class="box-title" style="margin:0px; padding: 0px;">Dristi Eye Hospital</h2>'
      );
      docprint.document.write(
          "<p style='text-transform: uppercase;'>Doctor Ledger<br/><strong>" +
          this.desserts[0].dr_name +
          " [" +
          this.desserts[0].dr_id +
          "]" +
          "</strong><br/>Date: " + date +
          "</p>"
      );
      docprint.document.write(
          '<div style="width: 100%;float: left;border-top: 5px solid silver;padding-bottom: 5px;"></div>'
      );
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
    printPaymentSummaryReport() {
      if (!this.isSuperAdmin) {
        this.$noty.error("Only Super Admin can print this report");
        return;
      }
      if (!this.doctor_id) {
        this.$noty.error("Please select a doctor");
        return;
      }
      if (!this.isDateRangeComplete) {
        this.$noty.error("Please select start and end date");
        return;
      }
      if (!this.validateSelectedDate()) {
        return;
      }
      const printUrl = this.returnApiBaseURL
          + "print/doctor-payment-statement-summary?doctor_id="
          + this.doctor_id
          + "&date="
          + this.normalizedDateRange.join(",")
          + "&login_user_id="
          + this.login_user_id;
      window.open(printUrl);
    },
  },
  watch: {
    'doctor_pay.received_by_type'(value) {
      if (value === 'Received By Doctor') {
        this.doctor_pay.received_by_user_id = '';
      }
    },
    doctor_id(newVal) {
      if (newVal) {
        this.doctor_pay.dr_id = newVal;
        if (this.isDateRangeComplete) {
          this.getReports();
        }
      } else {
        this.doctor_pay.dr_id = null;
        this.desserts = [];
      }
    },
    date: {
      deep: true,
      handler() {
        if (!this.isDateRangeComplete) {
          this.loadingstatus = false;
          this.errors = null;
        }
      },
    },
  }
};
</script>
